import type { BaseLegal } from '@eleg360/types';

export type { BaseLegal };

/**
 * O protótipo só desenha o link `wa.me` quando `c.base==='optin'`
 * (proto:1137, 1141) — qualquer outra base legal (opt-out ou nenhuma) fica
 * sem o botão, com o motivo no lugar dele.
 *
 * `BaseLegal` real (`packages/types/src/index.ts:70`) é
 * `'optin' | 'optout' | 'sem_base'` — o brief desta tarefa previa
 * `'optin' | 'legitimo' | 'contrato' | 'sem-base'`, que não existe em
 * nenhuma parte do sistema nem do protótipo. Usamos o tipo real.
 */
/**
 * A ÚNICA base legal que autoriza disparo. É o mesmo valor que o servidor
 * aplica em `campanhas.service.ts` (`calcularPublicoAlvo`,
 * `base_legal = 'optin'`) e que o worker reconfere no instante do envio
 * (`outbox.worker.ts`, "Contato sem opt-in no momento do envio").
 *
 * Existe como constante exportada para que as telas que montam filtro de
 * público não reescrevam o literal `'optin'` por conta própria — era assim
 * que a regra vivia em três lugares independentes, prontos para divergir.
 */
export const BASE_LEGAL_ENVIO: BaseLegal = 'optin';

/**
 * Com o que nasce quem é cadastrado sem ter consentido com nada.
 *
 * O caso é o contato rápido da agenda interna: alguém apareceu na visita e o
 * assessor anota o nome ali mesmo. Essa pessoa não autorizou contato — o
 * protótipo é explícito a respeito ("Nasce sem base legal", proto:1290), e o
 * valor existe aqui como constante pelo mesmo motivo de `BASE_LEGAL_ENVIO`:
 * para que nenhuma tela decida por conta própria com que base legal se cria
 * um cadastro.
 */
export const BASE_LEGAL_SEM_CONSENTIMENTO: BaseLegal = 'sem_base';

export function podeEnviarWhatsApp(c: { base_legal?: BaseLegal }): boolean {
  return c.base_legal === BASE_LEGAL_ENVIO;
}

/** Texto exibido no lugar do botão de WhatsApp quando o envio está bloqueado. */
export function motivoBloqueio(c: { base_legal?: BaseLegal }): string | null {
  if (c.base_legal === BASE_LEGAL_ENVIO) return null;
  if (c.base_legal === 'optout') {
    return 'Opt-out registrado: contato descadastrado, comunicação bloqueada.';
  }
  return 'Sem opt-in registrado: contato não pode receber WhatsApp.';
}
